export type PortalVersion = 'classic' | 'v2';

// 过渡期先通过系统更新通知介绍新版，暂不自动展示指引。
export const PORTAL_V2_GUIDE_ENABLED = false;

const PORTAL_VERSION_STORAGE_KEY = 'devops.portal.version';
const PORTAL_V2_GUIDE_STORAGE_KEY = 'devops.portal.v2.guide.seen';

export const getPortalVersion = (): PortalVersion => {
  if (typeof window === 'undefined') {
    return 'classic';
  }

  return window.localStorage.getItem(PORTAL_VERSION_STORAGE_KEY) === 'v2' ? 'v2' : 'classic';
};

export const setPortalVersion = (version: PortalVersion) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(PORTAL_VERSION_STORAGE_KEY, version);
  }
};

export const hasSeenPortalV2Guide = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    window.localStorage.getItem(PORTAL_V2_GUIDE_STORAGE_KEY) === 'true'
  );
};

export const markPortalV2GuideSeen = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(PORTAL_V2_GUIDE_STORAGE_KEY, 'true');
  }
};
